import axios from 'axios';
import {
  getToken,
  clearTokens,
} from '../services/LocalStorageService';
import { STATUSCODE } from '../common/constants';
import { sessionTimeout } from '../redux/actions/actions';
import store from '../redux/store/store';
//import logHandling from '../helper/logHandling';

const axiosInterceptor = (history) => {
  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = getToken();// Trae del local storage 'pimsWebAdmin' que tiene el token
      if (token) {
        /* eslint-disable */
        config.headers.Authorization = `Bearer ${token}`;
      }
      // eslint-disable-next-line no-use-before-define
      config.headers['Content-Type'] = 'application/json';
      return config;
    },
    (error) => Promise.reject(error),
  );
  /* eslint-enable */

  // Add a response interceptor
  axios.interceptors.response.use(
    (response) => {
      //console.log(response);
      return (response);
    },
    async (error) => {
      //console.log("INTERCEPTOR error: ",error);
      const originalRequest = error.config;
      const fromStorage = localStorage.getItem('pimsWebAdmin');
      //console.log("ER: ", error.response);
      if(error.response 
        && (error.response.status == 403 || error.response.status == 400)
        && error.response.data  
      ){
        console.log(error.response.data);
        originalRequest._retry = false;
        return Promise.reject(error.response);
      }
      // Si la creacion del refresh token no funciono vuelve a la pantalla de login - OK
      if (
        error.response
        && error.response.status === STATUSCODE.Unauthorized
        && originalRequest.url === 'api/auth/refresh-token'
        //&& fromStorage === null
      ) {
        //history.push('/login');
        store.dispatch(sessionTimeout());
        clearTokens();
        return Promise.reject(error);
      }
      if (
        error.response
        && error.response.status === STATUSCODE.Unauthorized
        && originalRequest.url !== 'api/auth/refresh-token'
        && fromStorage !== null
        // !originalRequest._retry
      ) {
        //logHandling.log('SECOND IF'); //Algo pasa que entra al if pero no continua
        originalRequest._retry = true;
        return axios({
          url: 'api/auth/refresh-token',
          method: 'POST',
        }).then((res) => {
          //logHandling.log('axios returned after recreate token: ',res.status);
          if (res.status === STATUSCODE.Created) {
            localStorage.setItem('pimsWebAdmin', res.data);
            axios.defaults.headers.common.Authorization = `Bearer ${getToken()}`;
            originalRequest._retry = false;
            return axios(originalRequest);
          }
        });
      }
      return Promise.reject(error);
    },
  );
};

export default axiosInterceptor;
